import React from 'react';

function Error() {
  return (
     <div style={{color: '#f00'}}>Error</div>
  );
}

export default Error;